import { useEffect } from "react";
import { formControls } from "../constants/forms";

export default function useDocumentNumberClearValues(
    quotationRHForm,
    documentNumberIsValidating
) {
    const { setValue } = quotationRHForm;
    useEffect(() => {
        if (!documentNumberIsValidating) {
            setValue(formControls.names.key, "");
            setValue(formControls.firstSurname.key, "");
            setValue(formControls.lastSurname.key, "");
            setValue(formControls.birthDate.key, null);
        }
    }, [documentNumberIsValidating, setValue]);
}
